import { module } from 'modujs';
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.wrap = this.el.querySelector('.realisation_progress');
        this.progressBar = this.el.querySelector('.realisation_progress_bar > div');
        this.progressValue = this.el.querySelector('.realisation_progress_value');
        
        window.addEventListener('realisationProgress', (e) => {
            const { target, progress } = e.detail;
            gsap.set(this.progressBar, { scaleX: progress });
            this.progressValue.textContent = Math.floor(progress * 100);

            if (progress > 0 && progress < 1) {
                this.wrap.classList.add('-visible');
            } else {
                this.wrap.classList.remove('-visible');
            }
        });
    }
}
